import { render, staticRenderFns } from "./LessGoodsList.vue?vue&type=template&id=1308858c&scoped=true&"
import script from "./LessGoodsList.vue?vue&type=script&lang=js&"
export * from "./LessGoodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1308858c",
  null
  
)

export default component.exports